export const DEFAULT_LOCALE = 'zh-Hans-CN'
export const ENGLISH_LOCALE = 'en-Latn-US'
export const LEGACY_ENGLISH_LOCALE = 'en'

export const LOCALE_OPTIONS = [
  { locale: 'zh-Hans-CN', title: '简体中文', flag: 'zh-Hans-CN' },
  { locale: 'zh-Hant-HK', title: '繁體中文', flag: 'zh-Hant-HK' },
  { locale: 'yue-Hant-HK', title: '粵語', flag: 'yue-Hant-HK' },
  { locale: 'en-Latn-US', title: 'English', flag: 'en-Latn-US' },
  { locale: 'ja-Jpan-JP', title: '日本語', flag: 'ja-Jpan-JP' },
  { locale: 'es-Latn-ES', title: 'Español', flag: 'es-Latn-ES' },
  { locale: 'pt-Latn-PT', title: 'Português', flag: 'pt-Latn-PT' },
  { locale: 'fr-Latn-FR', title: 'Français', flag: 'fr-Latn-FR' },
  { locale: 'de-Latn-DE', title: 'Deutsch', flag: 'de-Latn-DE' },
  { locale: 'id-Latn-ID', title: 'Bahasa Indonesia', flag: 'id-Latn-ID' },
]

const LOCALE_SET = new Set(LOCALE_OPTIONS.map((item) => item.locale))

export const LEGACY_LOCALE_MAP = {
  zh: 'zh-Hans-CN',
  'zh-cn': 'zh-Hans-CN',
  'zh-CN': 'zh-Hans-CN',
  'zh-Hans': 'zh-Hans-CN',
  'zh-Hans-CN': 'zh-Hans-CN',
  'zh-HK': 'zh-Hant-HK',
  'zh-TW': 'zh-Hant-HK',
  'zh-Hant': 'zh-Hant-HK',
  'zh-Hant-HK': 'zh-Hant-HK',
  'zh-Hant-TW': 'zh-Hant-HK',
  'yue-HK': 'yue-Hant-HK',
  yue: 'yue-Hant-HK',
  'yue-Hant': 'yue-Hant-HK',
  'yue-Hant-HK': 'yue-Hant-HK',
  en: 'en-Latn-US',
  'en-US': 'en-Latn-US',
  'en-GB': 'en-Latn-US',
  'en-Latn': 'en-Latn-US',
  'en-Latn-US': 'en-Latn-US',
  ja: 'ja-Jpan-JP',
  'ja-JP': 'ja-Jpan-JP',
  'ja-Jpan': 'ja-Jpan-JP',
  'ja-Jpan-JP': 'ja-Jpan-JP',
  es: 'es-Latn-ES',
  'es-ES': 'es-Latn-ES',
  'es-Latn': 'es-Latn-ES',
  'es-Latn-ES': 'es-Latn-ES',
  pt: 'pt-Latn-PT',
  'pt-PT': 'pt-Latn-PT',
  'pt-BR': 'pt-Latn-PT',
  'pt-Latn': 'pt-Latn-PT',
  'pt-Latn-PT': 'pt-Latn-PT',
  fr: 'fr-Latn-FR',
  'fr-FR': 'fr-Latn-FR',
  'fr-Latn': 'fr-Latn-FR',
  'fr-Latn-FR': 'fr-Latn-FR',
  de: 'de-Latn-DE',
  'de-DE': 'de-Latn-DE',
  'de-Latn': 'de-Latn-DE',
  'de-Latn-DE': 'de-Latn-DE',
  id: 'id-Latn-ID',
  'id-ID': 'id-Latn-ID',
  'id-Latn': 'id-Latn-ID',
  'id-Latn-ID': 'id-Latn-ID',
}

const BROWSER_LOCALE_RULES = [
  { locale: 'yue-Hant-HK', tags: ['yue', 'yue-hk', 'yue-hant', 'yue-hant-hk'] },
  { locale: 'zh-Hant-HK', tags: ['zh-hk', 'zh-tw', 'zh-mo', 'zh-hant', 'zh-hant-hk', 'zh-hant-tw', 'zh-hant-mo'] },
  { locale: 'zh-Hans-CN', tags: ['zh', 'zh-cn', 'zh-hans', 'zh-hans-cn', 'zh-sg'] },
  { locale: 'en-Latn-US', tags: ['en', 'en-us', 'en-gb', 'en-au', 'en-ca', 'en-latn', 'en-latn-us'] },
  { locale: 'ja-Jpan-JP', tags: ['ja', 'ja-jp', 'ja-jpan', 'ja-jpan-jp'] },
  { locale: 'es-Latn-ES', tags: ['es', 'es-es', 'es-mx', 'es-ar', 'es-co', 'es-cl', 'es-pe', 'es-latn', 'es-latn-es'] },
  { locale: 'pt-Latn-PT', tags: ['pt', 'pt-pt', 'pt-br', 'pt-latn', 'pt-latn-pt', 'pt-latn-br'] },
  { locale: 'fr-Latn-FR', tags: ['fr', 'fr-fr', 'fr-ca', 'fr-be', 'fr-ch', 'fr-latn', 'fr-latn-fr'] },
  { locale: 'de-Latn-DE', tags: ['de', 'de-de', 'de-at', 'de-ch', 'de-latn', 'de-latn-de'] },
  { locale: 'id-Latn-ID', tags: ['id', 'id-id', 'id-latn', 'id-latn-id'] },
]

export function normalizeLocale(input) {
  if (!input) return DEFAULT_LOCALE
  const raw = String(input).trim()
  if (LOCALE_SET.has(raw)) return raw
  const lower = raw.toLowerCase()
  if (LEGACY_LOCALE_MAP[raw]) return LEGACY_LOCALE_MAP[raw]
  if (LEGACY_LOCALE_MAP[lower]) return LEGACY_LOCALE_MAP[lower]
  return DEFAULT_LOCALE
}

function matchBrowserTag(tag) {
  const lower = String(tag).trim().toLowerCase()
  if (LEGACY_LOCALE_MAP[lower]) return LEGACY_LOCALE_MAP[lower]
  for (let i = 0; i < BROWSER_LOCALE_RULES.length; i++) {
    const rule = BROWSER_LOCALE_RULES[i]
    if (rule.tags.includes(lower)) return rule.locale
  }
  const main = lower.split('-')[0]
  for (let i = 0; i < BROWSER_LOCALE_RULES.length; i++) {
    const rule = BROWSER_LOCALE_RULES[i]
    if (rule.tags.some((item) => item === main || item.startsWith(main + '-'))) {
      return rule.locale
    }
  }
  return null
}

export function detectBrowserLocale() {
  const browserLanguages = navigator.languages || [navigator.language]
  for (let i = 0; i < browserLanguages.length; i++) {
    const matched = matchBrowserTag(browserLanguages[i])
    if (matched) return matched
  }
  return null
}

export function getStoredLocale() {
  return normalizeLocale(localStorage.getItem('language'))
}

export function persistLocale(locale) {
  const normalized = normalizeLocale(locale)
  localStorage.setItem('language', normalized)
  return normalized
}

export function toApiLanguage(locale) {
  const normalized = normalizeLocale(locale)
  const map = {
    'zh-Hans-CN': 'zh',
    'zh-Hant-HK': 'zh-HK',
    'yue-Hant-HK': 'zh-HK',
    'en-Latn-US': 'en',
    'ja-Jpan-JP': 'ja',
    'es-Latn-ES': 'es',
    'pt-Latn-PT': 'pt',
    'fr-Latn-FR': 'en',
    'de-Latn-DE': 'en',
    'id-Latn-ID': 'en',
  }
  return map[normalized] || 'en'
}

export function resolveAgreementLocale(locale) {
  const normalized = normalizeLocale(locale)
  const map = {
    'zh-Hans-CN': 'zh',
    'zh-Hant-HK': 'zh-HK',
    'yue-Hant-HK': 'zh-HK',
    'en-Latn-US': 'en',
    'ja-Jpan-JP': 'ja',
    'es-Latn-ES': 'es',
    'pt-Latn-PT': 'en',
    'fr-Latn-FR': 'en',
    'de-Latn-DE': 'en',
    'id-Latn-ID': 'en',
  }
  return map[normalized] || 'en'
}

export function isSimplifiedChinese(locale) {
  return normalizeLocale(locale) === 'zh-Hans-CN'
}

export function getLocaleFlag(locale) {
  const normalized = normalizeLocale(locale)
  const option = LOCALE_OPTIONS.find((item) => item.locale === normalized)
  return option ? option.flag : 'zh-Hans-CN'
}
